import gql from 'graphql-tag';
const verifyChef = gql`mutation addUserPayment($userId: ID!,$payment: PaymentMethodInput!) {
    addUserPayment(userId:$userId,payment:$payment)
}`
export default verifyChef;